import { CovFeatureGate } from "@cx-component-library/react-components/feature-flags";
import styled from "@emotion/styled";
import { Container } from "@mui/material";
import type { FC } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { FullScreenLoader } from "../../components/loader/FullScreenLoader";
import { useAppConfig } from "../../config/app-config";
import { NavigationGuardProvider } from "../../providers/NavigationGuardProvider";
import {
  UserInfoProvider,
  useUserInfoContext,
} from "../../providers/UserInfoProvider";
import { WhatsNewController } from "../dialog/WhatsNewController";
import { CovestroFooter } from "./CovestroFooter";
import { CovestroHeader } from "./CovestroHeader";
import { HeaderMessage } from "./HeaderMessage";

const AppTitle = styled.h1({
  margin: 0,
  padding: 0,
  paddingLeft: 8,
  paddingTop: 4,
  fontSize: "var(--body-b2-14-regular-size, 14px)",
  fontWeight: 500,
  fontFamily: 'var(--font-family, "AktivGrotesk")',
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  "@media (min-width: 900px)": {
    paddingLeft: 60,
    paddingTop: 7,
    fontSize: "var(--title-t2-18-regular-size, 18px)",
  },
});

export type LayoutProps = {};

const ACCESS_DENIED_PATH = "/access-denied";

const GatedOutlet: FC = () => {
  const { gateState } = useUserInfoContext();
  const location = useLocation();

  if (gateState === "checking" || gateState === "onboarding") {
    return <FullScreenLoader />;
  }

  if (gateState === "blocked" && location.pathname !== ACCESS_DENIED_PATH) {
    return <Navigate to={ACCESS_DENIED_PATH} replace />;
  }

  return <Outlet />;
};

export const Layout: FC<LayoutProps> = () => {
  const [appConfig] = useAppConfig();

  return (
    <UserInfoProvider>
      <NavigationGuardProvider>
        <CovestroHeader
          title={<AppTitle>Imagio® Color Finder</AppTitle>}
        ></CovestroHeader>
        {appConfig.message?.enabled && <HeaderMessage {...appConfig.message} />}
        <Container
          disableGutters={true}
          maxWidth={false}
          sx={{ overflowX: "hidden" }}
        >
          <GatedOutlet />
        </Container>
        <CovestroFooter />
        <CovFeatureGate flag="whatsNewDialog.enabled">
          <WhatsNewController />
        </CovFeatureGate>
      </NavigationGuardProvider>
    </UserInfoProvider>
  );
};
